var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.result)?_c('RenderAvatar',{staticStyle:{"width":"100%"},attrs:{"inheritedStringAvatar":_vm.stringAvatar}}):_c('RenderImage')
}
var staticRenderFns = []

export { render, staticRenderFns }